import { Button, DatePicker, message } from "antd";
import React, { useState } from "react";

import calendar from "../../assets/icons/calendar.png";

export default function CreateBoardFormAutomatedStepOne({ boardName, handleCreateBoard, isCreatingBoard }) {
  const [formData, setFormData] = useState({ from: "", to: "" });

  const handleNext = () => {
    if (!formData.from) {
      message.error("Please, enter a start date.");
      return;
    }
    if (!formData.to) {
      message.error("Please, enter an end date.");
      return;
    }
    if (formData.from > formData.to) {
      message.error("End date should be after the start date.");
      return
    }
    const today = new Date().toISOString().split('T')[0];
    if (today > formData.from) {
      message.error("Start date can not be before today.");
      return
    }

    handleCreateBoard(formData.from, formData.to)
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
      {/* Included Audience */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <p style={{ marginBottom: 0, fontSize: 14 }}>List Date</p>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
          <p style={{ marginBottom: 0, fontSize: 14 }}>From</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="list_start_date"
            placeholder="Select End Date"
            style={{ width: "85%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            onChange={(value) =>
              setFormData((prevData) => ({
                ...prevData,
                from: value ? value.format("YYYY-MM-DD") : "",
              }))
            }
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
          <p style={{ marginBottom: 0, fontSize: 14 }}>To</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="list_end_date"
            placeholder="Select End Date"
            style={{ width: "85%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            onChange={(value) =>
              setFormData((prevData) => ({
                ...prevData,
                to: value ? value.format("YYYY-MM-DD") : "",
              }))
            }
          />
        </div>
      </div>

      <Button
        type="primary"
        style={{ width: "100%", padding: "15px 0" }}
        onClick={handleNext}
        // disabled={!formData.from || !formData.to || !boardName}
        loading={isCreatingBoard}
      >
        Next
      </Button>
    </div>
  );
}
